import React from "react";
import Badge from "./Badge";
import { PROMOTION_STATUS_FILTERS, CAMPAIGN_STATUS_FILTERS, FilterValue } from "utils/promotionConstants";
import cx from "classnames";

interface PromotionFilterProps {
  selectedStatus: FilterValue;
  onStatusChange: (status: FilterValue) => void;
  className?: string;
  useStatusField?: boolean; // Use status field instead of promotionStatus
}

export default function PromotionFilter({
  selectedStatus,
  onStatusChange,
  className = "",
  useStatusField = false,
}: PromotionFilterProps) {
  const filters = useStatusField ? CAMPAIGN_STATUS_FILTERS : PROMOTION_STATUS_FILTERS;

  return (
    <div className={cx(
      "px-4 flex overflow-x-auto gap-2 mb-4 no-scrollbar",
      "[&::-webkit-scrollbar]:hidden",
      "[-ms-overflow-style:none]",
      "[scrollbar-width:none]",
      className
    )}>
      {filters.map((filter) => (
        <Badge
          key={filter.value}
          type="filter"
          label={filter.label}
          onClick={() => onStatusChange(filter.value)}
          isActive={filter.value === selectedStatus}
        />
      ))}
    </div>
  );
}